export function isActiveClassName(
  currentPath: string,
  targetPath: string,
  strictMode: boolean = false,
): string {
  // Strict mode on
  // The current and target path must be exactly the same

  if (strictMode) {
    return currentPath === targetPath ? 'active' : ''
  } else {
    // The target path only starts the same as the current path
    if (
      currentPath === targetPath ||
      currentPath.startsWith(targetPath + '/')
    ) {
      return 'active'
    }
  }

  return ''
}
